module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0106-0a66249942597f267952d41aacc7f2b0.png";